module.exports = __webpack_public_path__ + "static/media/bonusTransactionIcon.0e8ccdba.svg";